import { from, of } from "rxjs"
import { ofType } from "redux-observable"
import { switchMap, catchError, mergeMap } from "rxjs/operators"
import { push } from "connected-react-router"

import visibilityApi from "../../api/visibility-api"
import * as types from "./actionTypes"

import { getResequenceCarsSuccess } from "./actions"
import { hideLoader } from "../loader/actions"
import * as errorActions from "../error/actions"

export function fetcResequenceCars(action$) {
    return action$.pipe(
        ofType(types.GET_RESEQUENCE_CARS),
        switchMap((action) =>
            from(visibilityApi.getCarsForResequence(action.data)).pipe(
                mergeMap((data) =>
                    of(
                        getResequenceCarsSuccess(
                            data.RailcarsOnTrackToResequence
                        ),
                        hideLoader()
                    )
                ),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}
